import { AUTH_STORAGE_KEY } from '@src/corelib/auth/storages';
import { de, enUS, frCH, type Locale } from 'date-fns/locale';

function getLocaleForAuthUser() {
  let language = 'en-US';
  const value = localStorage.getItem(AUTH_STORAGE_KEY);
  if (value) {
    const authData = JSON.parse(value);
    if (authData) {
      const userLanguage = authData.user?.language;
      if (userLanguage) {
        language = userLanguage;
      }
    }
  }
  return language;
}
export const locale = getLocaleForAuthUser();

const adapterLocales: Record<string, Locale> = {
  'en-US': enUS,
  'de-CH': de,
  'fr-CH': frCH,
};
export const adapterLocale = adapterLocales[locale] || enUS;
